/**
 * Created by Bartosz.Pietrzyk on 2016-03-21.
 */
/**
 * resolutionsConfig default config on resolutions, can be override by object passed to constructor
 *
 */
export var resolutionsConfig = {
    smMin: 768,
    mdMin: 992,
    lgMin: 1200,
};
export default resolutionsConfig;
